//* DEPRECATED: change on AutocompleteOrganizers *//
<template lang="pug">
  div
    slot
      v-card.ev-card(
        v-if="items.length"
        color="primary"
        dark
        loading
        flat
        @click="openDialog"
      )
        v-card-text.text-center.py-2
          span.white--text.
            {{ selectedOrganization ? selectedOrganization.short_name || selectedOrganization.name : 'Выбрать организатора' }}
          p.caption {{ selectedOrganization ? selectedOrganization.fact_address : `Доступно ${items.length}` }}
            v-icon mdi-menu-down
      v-card(
        v-else
        flat
      )
        v-card-text.text-center.py-2
          template(v-if="!loading")
            span Организаторы не были найдены
          template(v-else)
            span Поиск организаторов...
            v-progress-linear(indeterminate color="primary")

    v-dialog(
      v-model="dialog"
      max-width="1000"
    )
      v-card.dialog__card
        v-card-title.primary
          span.white--text Выбрать организатора
          v-btn.ml-auto(icon color="white" @click="dialog = false")
            v-icon mdi-close

        v-card-text
          v-text-field.mt-3(
            v-show="items.length"
            v-model="searchValue"
            label="Поиск наименовании организации, ИНН или адресу"
            outlined
            dense
            clearable
            disable-pagination
          )
          v-data-table.mb-3(
            :items="filteredItems"
            :headers="headers"
            :page="page"
            :loading="loading"
            :server-items-length="items.length"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            hide-default-footer
          )
            template(#item.short_name="{ item }") {{ item.short_name }}
            template(#item.inn="{ item }") {{ item.inn }}
            template(#item.fact_address="{ item }") {{ item.fact_address }}
            template(#item.actions="{ item }")
              v-btn(
                v-bind="getActionData(item).component_attrs"
                @click="getActionData(item).component_listeners.click(item)"
              ) {{ getActionData(item).text }}
          v-alert(
            border="left"
            colored-border
            type="error"
            elevation="2"
          )
            p.
              Если в данном списке нет интересующей Вас организации,
              скорее всего она еще не подключилась к мероприятию. Повторите попытку после подключения организации.

</template>

<script>
export default {
  name: 'SelectEventOrganizers',
  props: {
    value: {
      type: Array,
      default: null,
    },
    regionId: {
      type: Number,
      default: null,
    },
    munId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      items: [],
      dialog: false,
      headers: [
        { value: 'actions', text: '', sortable: false },
        { value: 'short_name', text: 'Наименование' },
        { value: 'inn', text: 'ИНН' },
        { value: 'fact_address', text: 'Фактический адрес' },
      ],
      page: 1,
      searchValue: '',
      sortBy: null,
      sortDesc: false,
      loading: false,
      inputValue: this.value,
    };
  },
  computed: {
    filteredItems() {
      let { items } = this;
      if (this.searchValue) {
        const val = this.searchValue.toLowerCase();
        items = items.filter((item) => (
          item.short_name?.toLowerCase().includes(val)
          || item.inn?.toString().includes(val)
          || item.fact_address?.toLowerCase().includes(val)
        ));
      }

      if (this.sortBy) {
        items = items.sort((a, b) => {
          if (this.sortDesc) return a[this.sortBy] > b[this.sortBy] ? -1 : 1;
          return a[this.sortBy] < b[this.sortBy] ? -1 : 1;
        });
      }

      return items;
    },
    selectedOrganization() {
      const [organization] = this.inputValue;
      if (organization) {
        const organizationId = organization.id;
        return this.items.find((item) => item.id === organizationId);
      }

      return null;
    },
  },
  watch: {
    munId: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.items = [];
            this.getItems();
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    getActionData(value) {
      const [organization] = this.inputValue;
      const organizationId = organization?.id;
      if (organizationId === value.id) {
        return {
          text: 'Открепить',
          component_attrs: {
            color: 'error',
            title: 'Открепить организатора',
          },
          component_listeners: {
            click: (item) => this.unsetOrganizer(item),
          },
        };
      }

      return {
        text: 'Выбрать',
        component_attrs: {
          color: 'primary',
          title: 'Выбрать организатора',
        },
        component_listeners: {
          click: (item) => this.chooseOrganizer(item),
        },
      };
    },
    async getItems(page = 1) {
      this.loading = true;
      const params = {
        'per-page': -1,
        page,
      };
      // NOTE: Не уверен, что тут нужен `_or_null`
      if (this.regionId) {
        params['search[region_id_or_null]'] = this.regionId;
      }
      if (this.munId) {
        params['search[municipality_id_or_null]'] = this.munId;
      }

      await this.$rHandler(
        this.$api.user.getOrganizators(params),
        ({ data }) => { this.items = data.data; },
      );
      this.loading = false;
    },
    unsetOrganizer(item) {
      this.inputValue = [];
      this.dialog = false;
      this.$emit('unset', [item.id]);
    },
    chooseOrganizer(item) {
      this.inputValue = [item];
      this.dialog = false;
      this.$emit('input', [item.id]);
    },
    openDialog() {
      this.dialog = true;
    },
  },
};
</script>

<style scoped lang="scss">

  .v-select__selections span {
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
  }

  .dialog__card {
    background: #fff !important;
    border-radius: 10px;
    min-height: 500px;
  }

</style>
